const videoWarmPool = new Map();

export function preloadVideoUrl(href, { warmElement = true } = {}) {
  if (!href || typeof document === 'undefined') return;

  const attr = 'data-preload-video';
  if (!document.querySelector(`link[rel="preload"][${attr}="${href}"]`)) {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'video';
    link.href = href;
    link.type = 'video/mp4';
    link.setAttribute(attr, href);
    document.head.appendChild(link);
  }

  if (!warmElement) return;

  if (videoWarmPool.has(href)) {
    const existing = videoWarmPool.get(href);
    if (existing.preload !== 'auto') {
      existing.preload = 'auto';
      existing.load();
    }
    return;
  }

  const el = document.createElement('video');
  el.muted = true;
  el.playsInline = true;
  el.preload = 'auto';
  el.setAttribute('aria-hidden', 'true');
  el.setAttribute('data-preload-video-src', href);
  el.style.cssText =
    'position:fixed;width:0;height:0;opacity:0;pointer-events:none;left:-9999px;top:0';
  el.src = href;
  document.body.appendChild(el);
  videoWarmPool.set(href, el);
}

export function isVideoWarm(href) {
  if (!href) return false;
  const el = videoWarmPool.get(href);
  return Boolean(el && el.readyState >= 2);
}

export function whenVideoReady(href) {
  if (!href || typeof document === 'undefined') {
    return Promise.resolve();
  }

  const el = videoWarmPool.get(href);
  if (el && el.readyState >= 3) return Promise.resolve();
  if (el) {
    return new Promise((resolve) => {
      const done = () => resolve();
      el.addEventListener('canplay', done, { once: true });
      el.addEventListener('error', done, { once: true });
    });
  }

  preloadVideoUrl(href, { warmElement: true });
  return whenVideoReady(href);
}

export function prefetchGlobeModule() {
  return import('../components/home/GlobeCanvas').catch(() => {});
}

export function prefetchHomeRoute() {
  return import('../components/home/Home').catch(() => {});
}

export function prefetchBlogPageRoute() {
  return Promise.all([
    import('../components/blog-page/InsightsInnovation').catch(() => {}),
    import('../components/blog-page/HeroBlog').catch(() => {}),
    import('../components/blog-page/FeaturedBlogCardsRow').catch(() => {}),
  ]);
}

export function prefetchBlogDetailRoute() {
  return import('../components/blog/BlogDetail').catch(() => {});
}
